import { render, staticRenderFns } from "./AsignacionesMenu.vue?vue&type=template&id=2333ca60&scoped=true"
import script from "./AsignacionesMenu.vue?vue&type=script&lang=js"
export * from "./AsignacionesMenu.vue?vue&type=script&lang=js"
import style0 from "./AsignacionesMenu.vue?vue&type=style&index=0&id=2333ca60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2333ca60",
  null
  
)

export default component.exports